module.exports = __webpack_public_path__ + "static/media/Course summary React Fundamentals.0dee507e.pdf";